import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutModule } from './layout/layout.module';
import { PageModule } from './page/page.module';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    LayoutModule,
    PageModule
  ],
  exports: [
    LayoutModule,
    PageModule
  ]
})
export class RootModule { }
